/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext } from 'react';
import Layout from 'components/Layout';
import SubTitle from 'components/SubTitle';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import { Row, Col } from 'components/Grid';
import BrokingSummary from 'components/BrokingSummary';
import FileModal from 'components/FileModal';
import TagList2 from 'components/TagList2';
import { FitinsurAPI, MessageCenter } from 'utils';
import { useHistory } from 'react-router-dom';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Scrollbox, Footer, TagInput, PlaceHolder, ButtonContent } from './styles';
import { LostCancelButton, SchedullePeriods } from 'components/index';
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import HasPermission from 'components/HasPermission/index';
import {useScheduleReport, useSchedulleConfirm, useScheduleStatus, useHeaderNbi, useGetSchedulleAssumptions} from 'services/QuoteService';
import {useDeleteSchedulleAssumptions} from 'services/DocumentsService';


export default function ScheduleExibition(props) {

  const [file, setFile] = useState();
  const [summary, setSummary] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [showAttachments, setShowAttachments] = useState(false);
  const [isUpdatedSchedule, setIsUpdatedSchedule] = useState(props?.path?.includes('schedule-exibition-updated-schedule'));

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const history = useHistory();

  const goToLoginPage = () => {
    history.push('/login');
  };

  const {
    data: useScheduleReportData,
    loading: useScheduleReportLoading,
    error: useScheduleReportError,
    status: useScheduleReportStatus,
    request: useScheduleReportRequest,
  } = useScheduleReport(props.match.params.idOperation);

  const {
    data: useSchedulleConfirmData,
    loading: useSchedulleConfirmLoading,
    error: useSchedulleConfirmError,
    status: useSchedulleConfirmStatus,
    request: useSchedulleConfirmRequest,
  } = useSchedulleConfirm();

  const {
    data: useScheduleStatusData,
    loading: useScheduleStatusLoading,
    error: useScheduleStatusError,
    status: useScheduleStatusStatus,
    request: useScheduleStatusRequest,
  } = useScheduleStatus(props.match.params.idOperation);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useGetSchedulleAssumptionsData,
    loading: useGetSchedulleAssumptionsLoading,
    error: useGetSchedulleAssumptionsError,
    status: useGetSchedulleAssumptionsStatus,
    request: useGetSchedulleAssumptionsRequest,
  } = useGetSchedulleAssumptions(props.match.params.idOperation);

  const {
    data: useDeleteSchedulleAssumptionsData,
    loading: useDeleteSchedulleAssumptionsLoading,
    error: useDeleteSchedulleAssumptionsError,
    status: useDeleteSchedulleAssumptionsStatus,
    request: useDeleteSchedulleAssumptionsRequest,
  } = useDeleteSchedulleAssumptions();

  useEffect(() => {
    if (useScheduleReportLoading || useSchedulleConfirmLoading || useScheduleStatusLoading || useHeaderNbiLoading || useGetSchedulleAssumptionsLoading || useDeleteSchedulleAssumptionsLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useScheduleReportLoading, useSchedulleConfirmLoading, useScheduleStatusLoading, useHeaderNbiLoading, useGetSchedulleAssumptionsLoading, useDeleteSchedulleAssumptionsLoading]);

  function handleFile() {
    useScheduleReportRequest().then(({data}) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        setFile(data.ret_value);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
        console.error('fitPostDocument - Error:', error);
      });
  };

  function handleBack() {
    history.goBack();
  }

  function handleAction() {    
    useSchedulleConfirmRequest({idOperation: props.match.params.idOperation, isUpdatedSchedule: isUpdatedSchedule}, null).then(({data: res}) => {
      if (res.ret_code != 200) mc.error(res.ret_msg_details);
      if(isUpdatedSchedule) { 
        history.push('/policies');
      } else { 
        history.push(`/broking/market-composition/${props.match.params.idOperation}`, { idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null });
      }
    })

  };

  const checkStatus = () => {
    useScheduleStatusRequest().then(({data}) => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack()
          return;
        }
        setShowConfirm(!(data.ret_value.idDomainStatus == 33));
      })
  }

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          idOperation: props.match.params.idOperation,
        });
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  async function handleImport(file) {

    loading.start();
    const formData = new FormData();

    formData.append('fileDocument', file)
    formData.append('idOperation', props.match.params.idOperation)

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestSchedulleAssumptionsUpload(formData)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error(res.ret_msg_details);
          loading.stop();
          return;
        }
      })
      .then(_ => handleGetFiles())
      .catch(err => {
        mc.error("An error happened, please try again");
        loading.stop();
      });
  };

  function handleGetFiles() {
    useGetSchedulleAssumptionsRequest().then(({data: response}) => {
        const files = response.ret_value;
        let aux = [];

        files && files.forEach(file => {
          let obj = {
            dsTypeDocument: "Attachment",
            nameDocument: file.nameDocument,
            idTypeDocument: file.idTypeDocument,
            nameFile: file.nameFile,
            size: file.size,
            type: file.type,
            urlLink: file.urlLink,
            idDocument: file.idDocument
          };
          aux.push(obj);
        });
        setAttachments(aux);
        setShowAttachments(true);
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetFiles.name}\n` + error);
        console.error('fitPostFiles - Error:', error);
      });
  }

  function handleRmvAttach(index) {
    setAttachments(attachments.filter(tag => attachments.indexOf(tag) !== index));

    const idDocument = attachments[index].idDocument

    useDeleteSchedulleAssumptionsRequest({idOperation: props.match.params.idOperation, idDocument: idDocument }, null).then(({data: resp}) => {
        if (resp.ret_code !== 200) {
          mc.error(resp.ret_msg_details);
          return;
        } else {
          handleGetFiles();
        }
      })
      .catch(err => {
        mc.error("An error happened, please try again");
        loading.stop();
      });
  };

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    handleFile();
    if(!isUpdatedSchedule) handleGetFiles();
    handleSummary();
    checkStatus();
  }, []);


  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.nmObligor
        ? summary.nmObligor
        : "Broking name"
      }
      subtitle={summary.dealCode
        ? summary.dealCode
        : "Deal Code"
      }
    >
     <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} />  
      <BrokingSummary data={summary} />
      <Scrollbox>
        <ContentCard
          title="SCHEDULE"
          icon
          info={{
            idOperation: props.match?.params?.idOperation || null,
            idProduct: props.location?.state?.idProduct || null
          }}
        >
          <SchedullePeriods idOperation={props.match?.params?.idOperation} getLastImport/>
          <FileModal idOperation={props?.match?.params?.idOperation} file={file} />
          {!isUpdatedSchedule && (
            <Row>
              {showAttachments && (!attachments || !attachments.length)
                ? <Col md={3}>
                  <ButtonContainer>
                    <PlaceHolder htmlFor="fileInput" >UPLOAD FILE</PlaceHolder>
                    <TagInput
                      id="fileInput"
                      type="file"
                      multiple={false}
                      onChange={(event) => { handleImport(event.target.files[0]) }}
                    />
                  </ButtonContainer>
                </Col>
                : null
              }
              {showAttachments && (attachments && attachments.length)
                ? <Col md={6}>
                  <TagList2
                    tags={attachments}
                    disableType
                    hideTrash={false}
                    removeTag={(index) => handleRmvAttach(index)}
                  />
                </Col>
                : null
              }
            </Row>
          )}

          <Footer>
            <ButtonContainer>
              <Button forth onClick={() => handleBack()}>&lt; Back</Button>
              <RenderButtons idOperation={props.match?.params?.idOperation}>
                <ButtonContent>
                  <div style={{ marginTop: "5px" }}>
                    <LostCancelButton idOperation={props.match?.params?.idOperation} />
                  </div>
                  {isUpdatedSchedule || (showConfirm && attachments && attachments.length)
                    ? (
                      <HasPermission permission={props.permissions.IMPORT_SCHEDULE}>
                        <Button
                          primary
                          onClick={() => handleAction()}
                          style={{ marginLeft: "10px", marginTop: "5px" }}
                          >
                          CONFIRM SCHEDULE
                        </Button>
                      </HasPermission>
                    )
                    : null
                  }
                </ButtonContent>
              </RenderButtons>
            </ButtonContainer>
          </Footer>
        </ContentCard>
      </Scrollbox>
    </Layout >
  )
}
